module.exports = __webpack_public_path__ + "static/lightning-table-cell-highlight1-52036e646d3f1202a72449e232e63ee1.png";